var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#1C274C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3152_1087)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0103 15.0313C12.0103 12.154 14.5046 9.8855 17.4998 9.8855C20.495 9.8855 22.9894 12.154 22.9894 15.0313C22.9894 17.7308 21.3157 20.9001 18.6153 22.0541C17.9064 22.3571 17.0933 22.3571 16.3844 22.0541C13.684 20.9001 12.0103 17.7308 12.0103 15.0313ZM17.4998 10.948C15.0182 10.948 13.0728 12.8115 13.0728 15.0313C13.0728 17.3889 14.5641 20.1208 16.8019 21.0771C17.2441 21.2661 17.7555 21.2661 18.1978 21.0771C20.4356 20.1208 21.9269 17.3889 21.9269 15.0313C21.9269 12.8115 19.9814 10.948 17.4998 10.948ZM17.4998 14.4897C17.0108 14.4897 16.6144 14.8861 16.6144 15.3751C16.6144 15.8641 17.0108 16.2605 17.4998 16.2605C17.9888 16.2605 18.3853 15.8641 18.3853 15.3751C18.3853 14.8861 17.9888 14.4897 17.4998 14.4897ZM15.5519 15.3751C15.5519 14.2993 16.424 13.4272 17.4998 13.4272C18.5756 13.4272 19.4478 14.2993 19.4478 15.3751C19.4478 16.4509 18.5756 17.323 17.4998 17.323C16.424 17.323 15.5519 16.4509 15.5519 15.3751ZM11.5466 19.6227C11.7435 19.8401 11.7269 20.1761 11.5094 20.373C11.1073 20.7372 10.9478 21.0857 10.9478 21.3959C10.9478 21.9369 11.4606 22.6035 12.7092 23.1654C13.9079 23.7048 15.6012 24.0522 17.4998 24.0522C19.3985 24.0522 21.0918 23.7048 22.2905 23.1654C23.5391 22.6035 24.0519 21.9369 24.0519 21.3959C24.0519 21.0857 23.8924 20.7372 23.4903 20.373C23.2728 20.1761 23.2561 19.8401 23.4531 19.6227C23.65 19.4052 23.986 19.3885 24.2035 19.5855C24.7439 20.0748 25.1144 20.6884 25.1144 21.3959C25.1144 22.6154 24.0416 23.5425 22.7265 24.1343C21.3616 24.7485 19.5132 25.1147 17.4998 25.1147C15.4865 25.1147 13.6381 24.7485 12.2732 24.1343C10.9581 23.5425 9.88525 22.6154 9.88525 21.3959C9.88525 20.6884 10.2557 20.0748 10.7962 19.5855C11.0137 19.3885 11.3497 19.4052 11.5466 19.6227Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3152_1087"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLocation);
export default __webpack_public_path__ + "static/media/footer-location.36830bc32ad58dcaa7cd2d43a186e98a.svg";
export { ForwardRef as ReactComponent };